import styled, { css } from 'styled-components';

import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

export const CardCount = styled.div`
  position: absolute;
  left: 5px;
  bottom: 5px;
  height: 24px;
  width: 26px;
  background-color: var(--c-black);
  display: flex;
  justify-content: center;
  border-radius: var(--unit);
`;

export const ItemForSaleSecondRow = styled(SBHorizontal)`
  width: 100%;
  margin-bottom: var(--unit);
  height: var(--triple-unit);
  font: var(--t-14);
`;

export const ItemImgContainer = styled.div`
  --image-width: var(--card-mobile-width);
  flex-basis: var(--image-width);
  min-width: var(--image-width);
  aspect-ratio: var(--card-aspect-ratio);
  &.isDesktopLayout {
    --image-width: auto;
  }
`;

export const ItemInfosContainer = styled(Vertical).attrs({ gap: 0.5 })`
  flex: 1;
  &.isDesktopLayout {
    gap: var(--unit);
  }
`;

export const ItemPropertiesContainer = styled(Horizontal).attrs({ gap: 0 })`
  min-height: var(--quadruple-unit);
  color: var(--c-nd-600);
`;

export const TokenDetailsRoot = styled(Vertical).attrs({ as: 'div' })`
  font: var(--t-body-s);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--unit);
`;

export const TokenDetailsRow = styled(SBHorizontal)`
  width: 100%;
  min-height: var(--triple-unit);
  flex-wrap: wrap;
`;

export const ButtonContainer = styled.div<{ $isDesktopLayout?: boolean }>`
  ${({ $isDesktopLayout }) =>
    $isDesktopLayout !== undefined
      ? css`
          display: ${$isDesktopLayout ? 'block' : 'flex'};
        `
      : css`
          display: flex;
          @media ${tabletAndAbove} {
            display: block;
          }
        `}
`;
